export interface CreateOutsideProcessContractMovementForWorkOrderStageDto {
	dateSent?: Date;
	outsideProcessContractId: number;
	quantitySent: number;
	stillageNumber?: string;
	supplierId: number;
	workOrderStageId: number;
}

export class CreateOutsideProcessContractMovementForWorkOrderStageDto implements CreateOutsideProcessContractMovementForWorkOrderStageDto {
	constructor(data?: Partial<CreateOutsideProcessContractMovementForWorkOrderStageDto>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}